<template>
    <div class="subjectPlanning">
        <div class="content">
            <div class="withSubjectBox box">
                <p>
                    <el-checkbox v-model="isGetSubject" @change="onGetSubject">关联该学生选科系统结果</el-checkbox>
                </p>
                <div v-show="isGetSubject">
                    <template v-if="hadCheckedList.length">
                        <el-checkbox-group :value="chooseSubjectObj.hadCheckedList">
                            <el-checkbox :label="item" v-for="(item,index) in subjectName" :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </template>
                    <template v-else>
                        <p class="detail">暂无选科内容</p>
                    </template>
                </div>
            </div>
            <div class="check box" v-if="!isGetSubject">
                <p class="title">
                    选科方案<span>（最多只能选3科）</span>
                </p>
                <el-checkbox-group v-model="chooseSubjectObj.chooseSubjectName" :max="3">
                    <el-checkbox :label="item" v-for="(item,index) in subjectName" :key="index"></el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="tableBox">
                <CircleName name='目标院校对目标专业的选科要求' />
                <table v-if="chooseSubjectObj.chooseSubjectRequire.length">
                    <tbody>
                    <tr class="titleBox">
                        <th>目标专业</th>
                        <th v-for="(value,index) in chooseSubjectObj.chooseSubjectRequire[0].list">{{value.school}}</th>
                    </tr>
                    <tr v-for="(value,index) in chooseSubjectObj.chooseSubjectRequire" :key="index">
                        <th>{{value.subject}}</th>
                        <td v-for="(child,idx) in value.list" :key="idx">
                            <el-input v-model="child.require"></el-input>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="summary">
                <SummaryTitle title='咨询记录'/>
                <el-input class="area"  type="textarea" v-model="chooseSubjectObj.chooseSubjectRemark"  rows="5" maxLength='500'></el-input>
            </div>
        </div>
    </div>
</template>
<script>
import SummaryTitle from './SummaryTitle.vue';
import CircleName from './CircleName.vue';
export default {
    name: "subjectPlanning",
    props: ['chooseSubjectObj','careerMajorObj','goalPlanObj'],
    components: {
        SummaryTitle,
        CircleName
    },
    data() {
        return {
            studentId: sessionStorage.getItem('myStudentStudentId'),
            isGetSubject: false,
            hadCheckedList: [],
            chooseSubjectRequire: [],
            subjectName: ['物理', '化学', '生物', '历史', '地理', '思想政治'],
        }
    },
    computed:{

    },
    watch: {

    },
    methods:{
        onGetSubject(value) {
            if(value) {
                this.getLastChooseSubjectName();
            }
        },
        getLastChooseSubjectName() {
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getLastChooseSubjectName, {
                studentId: studentId
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    this.hadCheckedList = res.data.data.data;
                    this.chooseSubjectObj.hadCheckedList = this.hadCheckedList
                }
            })

        },
        // 获取生涯测评职业领域、目标职业、目标专业
        getCareerMajor(){
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getCareerMajor, {
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    this.careerData = res.data.data;
                }else{

                }
            })
        },
        getSubjectRequire() {
            let targetSubject = this.careerMajorObj.targetSubject;
            let universityIdName = this.goalPlanObj.universityIdName;
            let chooseSubjectRequire = [];
            if(targetSubject.length&&universityIdName.length) {
                targetSubject.forEach((value)=>{
                    let obj = {};
                    let arr = [];
                    obj.subject = value;
                    universityIdName.forEach((child) =>{
                        let obj2 = {};
                        obj2.school = child.name;
                        obj2.require = '';
                        arr.push(obj2)
                    })
                    obj.list = arr;
                    chooseSubjectRequire.push(obj);
                })
                this.chooseSubjectObj.chooseSubjectRequire =  chooseSubjectRequire;
            }
        }

    },
    created() {
        this.getSubjectRequire();
    },
    mounted(){
    },
    activated() {
        this.getSubjectRequire();
    }
}
</script>
<style scoped lang="less">
.subjectPlanning {
    padding: 26px 0px;
    .mainBox {
        .mainTitle {
            font-size: 20px;
            font-weight: bold;
        }
    }
    .content {
        background-color: #fff;
        .box {
            margin-bottom: 30px;
        }
        .check {
            //padding-top: 30px;
            .title {
                font-size: 20px;
                font-weight: bold;
                line-height: 30px;
                margin-bottom: 10px;
                span {
                    font-size: 12px;
                }
            }
        }
        .withSubjectBox {
            margin-bottom: 20px;
            .btn {
                margin-bottom: 10px;
            }
            .detail {
                font-size: 20px;
                font-weight: bold;
                line-height:40px;
            }
        }
        .tableBox {
            margin-bottom: 20px;
            table {
                margin-top: 10px;
                width: 100%;
                tr {
                    th {
                        line-height: 40px;
                        text-align: center;
                        background: rgba(61, 144, 246, 0.1);
                        border: 1px solid rgba(61, 144, 246, 0.2);
                    }
                    td {
                        line-height: 40px;
                        font-size: 14px;
                        border: 1px solid rgba(61, 144, 246, 0.2);
                    }
                }
                .titleBox {
                    th {
                        font-size: 16px;
                        background: rgba(61, 144, 246, 0.2);
                        border: 1px solid rgba(61, 144, 246, 0.2);
                    }
                }

            }
        }
    }
}
</style>
<style lang="less">
.subjectPlanning {
    input {
        border: none;
    }
}
</style>

